import { LOCALE_ID, NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { Router, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { BasketComponent } from './basket/basket.component';
import { CategoryComponent } from './category/category.component';
import { ControlComponent } from './control/control.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { HelpTriangleComponent } from './shared/components/help-triangle/help-triangle.component';
import { ModalComponent } from './shared/components/modal/modal.component';
import { HttpClientModule } from '@angular/common/http';
import { ConfigComponent } from './config/config.component';
import { FormsModule } from '@angular/forms';
import { registerLocaleData } from '@angular/common';
import localeDECH from '@angular/common/locales/de-CH';
import { LocaleService } from './shared/services';
import { ImageFallbackDirective } from './shared/directives/image-fallback.directive';
registerLocaleData(localeDECH);
import { QrCodeModule } from 'ng-qrcode';
import { ErrorModalComponent } from "./shared/modals/error-modal/error-modal.component";
import { SetImagePipe } from './shared/pipes/image.pipe';
import * as Sentry from "@sentry/angular";

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LayoutComponent,
    BasketComponent,
    CategoryComponent,
    ControlComponent,
    CheckoutComponent,
    HelpTriangleComponent,
    ModalComponent,
    ConfigComponent,
    ImageFallbackDirective,
    SetImagePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    RouterModule,
    HttpClientModule,
    FormsModule,
    QrCodeModule,
    ErrorModalComponent
],
  exports: [
    RouterModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "de-CH" },
    LocaleService,
    SetImagePipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
